/* Keep Slick navigation and hidden-slide state; remove its misleading form listbox semantics. */
(function () {
  function fix(root) {
    (root || document).querySelectorAll('.slick-track[role="listbox"]').forEach(function (track) {
      track.setAttribute('role', 'presentation');
      track.querySelectorAll('.slick-slide[role="option"]').forEach(function (slide) {
        slide.setAttribute('role', 'group');
        slide.setAttribute('aria-roledescription', 'slide');
        slide.removeAttribute('aria-selected');
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { fix(); }, {once:true});
  else fix();
  if (window.jQuery) window.jQuery(document).on('init.mtmukA11y reInit.mtmukA11y afterChange.mtmukA11y', function (event, slick) {
    if (slick && slick.$slider) setTimeout(function () { fix(slick.$slider[0]); }, 0);
  });
  window.addEventListener('load', function () { fix(); }, {once:true});
}());
